import { useState } from 'react';
import { MultiInput, Stack, Text } from 'shell/components';
import { emailRegex } from 'utils/regex';
import { v4 as uuid } from 'uuid';

const MultiInputDemo = () => {
    const [inputValue1, setInputValue1] = useState('');
    const [values1, setValues1] = useState([]);

    const [inputValue2, setInputValue2] = useState('');
    const [values2, setValues2] = useState([]);

    const [inputValue3, setInputValue3] = useState('');
    const [values3, setValues3] = useState([]);

    return (
        <>
            <Text variant={'sh1'}>MultiInput</Text>
            <Stack sx={{ width: '300px' }} spacing={2}>
                <MultiInput
                    inputValue={inputValue1}
                    placeholder={'Placeholder'}
                    value={values1}
                    onChange={(e) => setInputValue1(e.target.value)}
                    onAddChip={(value) => {
                        setValues1((current) => [...current, { key: uuid(), value }]);
                        setInputValue1('');
                    }}
                    onRemoveChip={(item) => {
                        setValues1((current) => current.filter(({ key }) => key !== item.key));
                    }}
                />
                <MultiInput
                    helperText={'Assistive Text'}
                    inputValue={inputValue1}
                    placeholder={'Placeholder'}
                    value={values1}
                    onChange={(e) => setInputValue1(e.target.value)}
                    onAddChip={(value) => {
                        setValues1((current) => [...current, { key: uuid(), value }]);
                        setInputValue1('');
                    }}
                    onRemoveChip={(item) => {
                        setValues1((current) => current.filter(({ key }) => key !== item.key));
                    }}
                />
                <MultiInput
                    error
                    helperText={'Error Message'}
                    inputValue={inputValue1}
                    placeholder={'Placeholder'}
                    value={values1}
                    onChange={(e) => setInputValue1(e.target.value)}
                    onAddChip={(value) => {
                        setValues1((current) => [...current, { key: uuid(), value }]);
                        setInputValue1('');
                    }}
                    onRemoveChip={(item) => {
                        setValues1((current) => current.filter(({ key }) => key !== item.key));
                    }}
                />
                <MultiInput
                    error={values2.some((item) => item.error)}
                    inputValue={inputValue2}
                    placeholder={'Enter an email'}
                    value={values2}
                    onChange={(e) => setInputValue2(e.target.value)}
                    onAddChip={(value) => {
                        setValues2((current) => [
                            ...current,
                            { key: uuid(), value, error: !emailRegex.test(value) },
                        ]);
                        setInputValue2('');
                    }}
                    onRemoveChip={(item) => {
                        setValues2((current) => current.filter(({ key }) => key !== item.key));
                    }}
                />
                <MultiInput
                    error={values3.some((item) => item.error)}
                    inputValue={inputValue3}
                    placeholder={'With asynchronous validation'}
                    value={values3}
                    onChange={(e) => setInputValue3(e.target.value)}
                    onAddChip={(value) => {
                        const newItemId = uuid();
                        const newItem = { key: newItemId, value, loading: true };
                        setValues3((current) => [...current, newItem]);
                        setInputValue3('');
                        // simulate async validation
                        setTimeout(() => {
                            setValues3((current) => {
                                return current.map((item) => ({ ...item, loading: false, error: true }));
                            });
                        }, 3000);
                    }}
                    onRemoveChip={(item) => {
                        setValues3((current) => current.filter(({ key }) => key !== item.key));
                    }}
                />
            </Stack>
        </>
    );
};

export default MultiInputDemo;
